import { render, staticRenderFns } from "./cardCommonConfig.vue?vue&type=template&id=fb056f10&scoped=true"
import script from "./cardCommonConfig.vue?vue&type=script&lang=js"
export * from "./cardCommonConfig.vue?vue&type=script&lang=js"
import style0 from "./cardCommonConfig.vue?vue&type=style&index=0&id=fb056f10&lang=scss&scoped=true"
import style1 from "./cardCommonConfig.vue?vue&type=style&index=1&id=fb056f10&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.34_babel-core@7.0.0-bridge.0_@babel+core@7.0.0_f2752dac7684e9922cbc3a420999c69f/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fb056f10",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/lib/jenkins/workspace/staging_gift_admin_deploy/node_modules/.pnpm/vue-hot-reload-api@2.3.4/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('fb056f10')) {
      api.createRecord('fb056f10', component.options)
    } else {
      api.reload('fb056f10', component.options)
    }
    module.hot.accept("./cardCommonConfig.vue?vue&type=template&id=fb056f10&scoped=true", function () {
      api.rerender('fb056f10', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/cardCommonConfig.vue"
export default component.exports